<div class="filter-bar" #flt>
  <p-dropdown [options]="services" [(ngModel)]="getFilters().serviceCode" (onChange)="onChangeStatus($event, 'SERVICE')"
    class="filter-item">
    <ng-template let-service pTemplate="item">
      <div class="p-helper-clearfix" style="position: relative;height: 25px;">
        <img *ngIf="service.value && service.value != ''" src="{{getIcon(service.value)}}" style="width:24px;height:24px;position:absolute;top:1px;left:5px"
        />
        <div class="drp-dwn-lbl w-300 m-40">{{service.label}}</div>
      </div>
    </ng-template>
  </p-dropdown>

  <p-dropdown [options]="statuses" [(ngModel)]="getFilters().statusCode" (onChange)="onChangeStatus($event, 'STATUS')"
    class="filter-item">
    <ng-template let-status pTemplate="item">
      <div class="p-helper-clearfix" style="position: relative;height: 25px;">
        <div class="drp-dwn-lbl w-150">{{status.label}}</div>
      </div>
    </ng-template>
  </p-dropdown>

  <p-dropdown [options]="responsibleGroups" [(ngModel)]="getFilters().responsibleGroup" (onChange)="onChangeStatus($event, 'RESPONSIBLE_GROUP')"
    [appendTo]="flt" class="filter-item">
    <ng-template let-responsibleGroup pTemplate="item">
      <div class="p-helper-clearfix" style="position: relative;height: 25px;">
        <div class="drp-dwn-lbl w-230">{{responsibleGroup.label}}</div>
      </div>
    </ng-template>
  </p-dropdown>

  <p-dropdown [options]="responsibles" [(ngModel)]="getFilters().responsibleUser" (onChange)="onChangeStatus($event, 'RESPONSIBLE')"
    class="filter-item">
    <ng-template let-responsible pTemplate="item">
      <div class="p-helper-clearfix" style="position: relative;height: 25px;">
        <div class="drp-dwn-lbl w-300">{{responsible.label}}</div>
      </div>
    </ng-template>
  </p-dropdown>


  <button type="button" class="btn btn-default" (click)="onResetFilter()">
    <span class="fa fa-times"></span>
    <span class="lbl">{{'components.requestFilterComponent.reset' | translate}}</span>
  </button>
</div>
